import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ParseService } from '../../../../../shared/common/parse/parse.service';
import { ProfilehelperDD } from '../../../../../shared/common/helper/personaldetails-helper';
import { ProfileService } from '../../profile.service';
import { ToastBaseModel } from '../../../../../shared/common/toast-data-model';
import { QueryInterface } from '../../../../../shared/common/parse/query-interface';
import { GetSetOperations } from '../../../../../shared/common/helper/profile';
import { GetOperations } from 'app/shared/common/helper/dropdown';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { Router, ActivatedRoute } from '@angular/router';
import { CountryISO, SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-demographic',
  templateUrl: './demographic.component.html',
  styleUrls: ['./demographic.component.scss']
})

export class DemographicComponent implements OnInit {

  personalDetailsForm: FormGroup;
  about: any;
  userroles: any;
  userroles1: any;
  profileroles: any;
  profileDetails: any;
  instance: any;
  religionvalue: any;
  formErrors: any;
  user_id = this.parseService.instance.User.current();
  profileValue: any;
  twilightDetailsForm: FormGroup;
  profileDetails1: any;
  organisationLists = [];
  locationList = [];
  seatingLists: any;
  departmentList = [];
  reportingtoList = [];
  reportList = []
  currentDate: any;
  designationList = [];
  roleList = [];
  genderList = [];
  maritalStatusList = [];
  religionList = [];
  bloodGroupList = [];
  startTimeList = [];
  locationObj: any;
  organisationobj: any;
  departmentobj: any;
  profileId: any;
  objectId = this.parseService.instance.User.current().id;
  location = [];
  role = [];
  organisation = [];
  department = [];
  organisationInfo = [{}];
  locationInfo = [{}];
  departmentInfo = [{}];
  designationInfo = [{}];
  roleInfo = [{}];
  empRole = '';
  today = new Date().getFullYear();
  miDate = this.today - 60;
  maDate = this.today - 18;
  minDate = new Date(this.miDate, 11, 31);
  maxDate = new Date(this.maDate, 11, 31);
  tenantId = '';
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  industryId: any;
  ispersonalDetailsFormUpdated: boolean;
  isMobileNumberEmpty: boolean = false;
  mobileNumber: any;
  usersProfileId = undefined;

  constructor(
    private toastMessage: ToastBaseModel,
    private profileService: ProfileService,
    private formBuilder: FormBuilder,
    private parseService: ParseService,
    private _helper: ProfilehelperDD,
    private toastr: ToastrService,
    private queryInterface: QueryInterface,
    private profileInterface: GetSetOperations,
    private profileDropDown: GetOperations,
    private dateConvertor: DateConvertor,
    private storageConfiguration: StorageConfiguration,
    private router: Router,
    private route: ActivatedRoute

  ) {
    this.route.params.subscribe(async params => {
      if (params['id']) {
        this.usersProfileId = params['id'];
      }
    });
    // this.getTwilightDetails();
    this.profileService.aboutOnChanged.subscribe(about => {
      this.about = about;
    });
    this.reportingtoList = this._helper.reportingtoLists;
    this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
    // this.createTwilightDetailsForm();
  }

  ngOnInit(): void {
    (async () => {
      this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
      this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);

      // PERSONAL DETAILS VALIDATION
      this.personalDetailsForm = this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        gender: ['', Validators.required],
        dob: ['', Validators.required],
        personalEmail: ['', [Validators.required, Validators.email]],
        mobileNo: ['', Validators.required],
        alternateMobileNo: [''],
        emergencyMobileNo: [''],
        permanentAddress: [''],
        currentAddress: [''],
        // bloodGroup: ['', Validators.required],
        // martialStatus: [''],
        about: [''],
        // religion: ['', Validators.required],
      });

      this.currentDate = new Date();
      this.personalDetailsForm.valueChanges.subscribe(() => {
        this.onFormValuesChanged('personalDetailsForm');
      });

      this.getDropDowns();
      this.getLocation();
      this.getRole();
      this.getOrganisation();
      this.getDepartment();
      // this.getReportingTo();
      await this.getUserByProfileID(this.usersProfileId).catch(() => {
        console.log('This is own profile');
      });
      this.getPersonalDetails();

      function stopRKey(evt) {
        var evt = (evt) ? evt : ((event) ? event : null);
        var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
        if ((evt.keyCode == 13) && (node.type == 'text')) { return false; }
      }

      document.onkeypress = stopRKey;
    })();
  }

  // createTwilightDetailsForm(): void{
  //   this.twilightDetailsForm = this.formBuilder.group({
  //     organisationId: ['', Validators.required],
  //     locationId: ['', Validators.required],
  //     seatNo: ['', Validators.required],
  //     doj: ['', Validators.required],
  //     departmentId: ['', Validators.required],
  //     officialEmail: ['', [Validators.required, Validators.email]],
  //     yearofExperiences: ['', Validators.compose([Validators.maxLength(2), Validators.max(99), Validators.required])],
  //     months: ['', Validators.compose([Validators.maxLength(2), Validators.max(11), Validators.required])],
  //     gitUserId: ['', Validators.required],
  //     startTime: ['', Validators.required],
  //     roleId: ['', Validators.required],
  //     reporterId: ['', Validators.required],
  //     reportingDate: ['', Validators.required],
  //     panNumber: [''],
  //     salaryAccountNumber: [''],
  //     personalAccountNumber: ['']
  //   });
  // }

  keyPress(event: any) {
    const pattern = /[0-9\+\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  /*
  ** ==========================================================
  ** Get Personal Details Function
  ** ==========================================================
  */

  getPersonalDetails() {
    this.queryInterface.executeQuery(this.parseService, 'User', [{ condition: 'equalTo', field: 'objectId', value: this.objectId },
    { condition: 'include', value: 'profile' }]).then(result => {
      var results = result[0];
      let jsonText = JSON.stringify(results);
      let userProfile = JSON.parse(jsonText);
      this.profileValue = userProfile;
      let personalInfo = this.profileValue.profile.personalInfo
      this.profileId = this.profileValue.profile.objectId
      this.personalDetailsForm.patchValue({
        firstName: this.profileValue.firstName,
        lastName: this.profileValue.lastName,
        gender: personalInfo.gender,
        dob: personalInfo.dob,
        personalEmail: personalInfo.personalEmail,
        mobileNo: personalInfo.mobileNo.number ? personalInfo.mobileNo.number : personalInfo.mobileNo ? personalInfo.mobileNo : '',
        alternateMobileNo: personalInfo.alternateMobileNo,
        emergencyMobileNo: personalInfo.emergencyMobileNo,
        permanentAddress: personalInfo.permanentAddress,
        currentAddress: personalInfo.currentAddress,
        // bloodGroup: personalInfo.bloodGroup,
        // martialStatus: personalInfo.martialStatus,
        about: personalInfo.about,
        // religion: personalInfo.religion
      });
      if (this.personalDetailsForm.valid) {
        this.ispersonalDetailsFormUpdated = true;
      }
    });
  }

  /*
  ** ==========================================================
  ** Personal Details Save Function
  ** ==========================================================
  */
  public personalSave() {
    if (this.personalDetailsForm.value.mobileNo == null) this.isMobileNumberEmpty = true;
    /**
     * * Check mobile and Emergency number are same
     */
    if (this.personalDetailsForm.value.mobileNo && this.personalDetailsForm.value.emergencyMobileNo) {
      if (this.personalDetailsForm.value.mobileNo.internationalNumber === this.personalDetailsForm.value.emergencyMobileNo.internationalNumber) {
        return;
      }
    }
    let profileValues = this.personalDetailsForm.value;
    var firstName = profileValues.firstName
    var lastName = profileValues.lastName
    let data = {
      personalInfo: {
        gender: profileValues.gender,
        dob: this.dateConvertor.addGMTOffset(new Date(profileValues.dob)).toISOString(),
        personalEmail: profileValues.personalEmail,
        mobileNo: profileValues.mobileNo ? profileValues.mobileNo : '',
        alternateMobileNo: profileValues.alternateMobileNo ? profileValues.alternateMobileNo : '',
        emergencyMobileNo: profileValues.emergencyMobileNo ? profileValues.emergencyMobileNo : '',
        permanentAddress: profileValues.permanentAddress,
        currentAddress: profileValues.currentAddress,
        // bloodGroup: profileValues.bloodGroup,
        // martialStatus: profileValues.martialStatus,
        about: profileValues.about,
        // religion: profileValues.religion,
        firstName,
        lastName
      }
    };
    /**
     * * Update the users firstName and lastName in the user table
     */
    // if (this.profileValue.firstName !== profileValues.firstName || this.profileValue.lastName !== profileValues.lastName ){
    this.queryInterface.executeQuery(this.parseService, 'User', [{ condition: 'equalTo', field: 'objectId', value: this.objectId },
    { condition: 'include', value: 'profile' }]).then(result => {
      const results = result[0];
      results.set('firstName', profileValues.firstName);
      results.set('lastName', profileValues.lastName);
      results.save();
    });
    // }
    if (this.personalDetailsForm.valid) {
      this.profileInterface.updatePersonal(this.profileId, data, firstName, lastName);
      if (this.ispersonalDetailsFormUpdated) {
        this.toastr.success(this.toastMessage.Update);
      } else {
        this.toastr.success(this.toastMessage.Save);
      }
    } else {
      if (this.personalDetailsForm.controls.mobileNo.errors) {
        if (this.personalDetailsForm.controls.mobileNo.errors.required) {
          this.toastr.error('Mobile number is required');
        }
        if (this.personalDetailsForm.controls.mobileNo.errors.validatePhoneNumber) {
          this.toastr.error('Mobile number is  invalid');
        }
      }
      if (this.personalDetailsForm.controls.emergencyMobileNo.errors) {
        if (this.personalDetailsForm.controls.emergencyMobileNo.errors.required) {
          this.toastr.error('Emergency Mobile number is required');
        }
        if (this.personalDetailsForm.controls.emergencyMobileNo.errors.validatePhoneNumber) {
          this.toastr.error('Emergency Mobile number is invalid');
        }
      }
      if (this.personalDetailsForm.controls.alternateMobileNo.errors) {
        if (this.personalDetailsForm.controls.alternateMobileNo.errors.validatePhoneNumber) {
          this.toastr.error('Alternative Mobile number is invalid');
        }
      }
    }
  }

  async getUserByProfileID(profileId): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!profileId) {
        reject(this.objectId);
      }
      const UserClass = new this.parseService.instance.Query('User');
      UserClass.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
      let user = await UserClass.find();
      if (user.length) {
        user = user[0];
        this.objectId = user.id;
        resolve(this.objectId);
      } else {
        reject(this.objectId);
      }
    });
  }

  /*
  ** ==========================================================
  ** Twilight Details Get Function
  ** ==========================================================
  */

  // getTwilightDetails() {
  //   this.queryInterface.executeQuery(this.parseService, "User", [{ condition: "equalTo", field: "objectId", value: this.objectId },
  //   { condition: "include", value: "profile" }]).then(result => {
  //     var results = result[0];
  //     let jsonText = JSON.stringify(results);
  //     let userProfile = JSON.parse(jsonText);
  //     this.profileValue = userProfile.profile;

  //     if (this.profileValue.officialInfo.experience == undefined) {
  //       this.profileValue.officialInfo.experience = { year: '', month: '' };
  //     }
  //     this.twilightDetailsForm.patchValue({
  //       locationId: this.profileValue.location == undefined ? "" : this.profileValue.location.objectId,
  //       organisationId: this.profileValue.organisation == undefined ? "" : this.profileValue.organisation.objectId,
  //       departmentId: this.profileValue.department == undefined ? "" : this.profileValue.department.objectId,
  //       roleId: this.profileValue.role == undefined ? "" : this.profileValue.role.objectId,
  //       reporterId: this.profileValue.reportingTo == undefined ? "" : this.profileValue.reportingTo.objectId,
  //       seatNo: this.profileValue.officialInfo.seatNo,
  //       reportingDate: this.profileValue.officialInfo.reportingDate,
  //       doj: this.profileValue.officialInfo.doj,
  //       officialEmail: this.profileValue.officialInfo.officialEmail,
  //       gitUserId: this.profileValue.officialInfo.gitUserId,
  //       billableStatus: this.profileValue.billableStatus,
  //       yearofExperiences: this.profileValue.officialInfo.experience.year == undefined ? 0 : this.profileValue.officialInfo.experience.year,
  //       months: this.profileValue.officialInfo.experience.month == undefined ? 0 : this.profileValue.officialInfo.experience.month,
  //       startTime: this.profileValue.officialInfo.startTime,
  //       panNumber: this.profileValue.officialInfo.panNumber,
  //       salaryAccountNumber: this.profileValue.officialInfo.salaryAccountNumber,
  //       personalAccountNumber: this.profileValue.officialInfo.personalAccountNumber
  //     });
  //   }).catch(err => {
  //     console.log('Oh noooo!!');
  //     console.log(err);
  //   });
  // }

  getDepartmentId() {
    let departmentId = '';
    this.profileValue.department.forEach(element => {
      if (element.isActive) {
        departmentId = element.objectId;
      }
    });
    return departmentId;
  }

  getLocationId() {
    let locationId = '';
    this.profileValue.locationInfo.forEach(element => {
      if (element.isActive) {
        locationId = element.objectId;
      }
    });
    return locationId;
  }

  getOrganisationId() {
    let organisationId = '';
    this.profileValue.organisation.forEach(element => {
      if (element.isActive) {
        organisationId = element.objectId;
      }
    });
    return organisationId;
  }

  async getLocation() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Location', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    { field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let locationInfo = JSON.parse(jsonText);
        result.push({ id: locationInfo.objectId, name: locationInfo.name });
      }
      this.locationList = result;
    });
  }

  async getOrganisation() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Organisation', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    { field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let organisationInfo = JSON.parse(jsonText);
        result.push({
          id: organisationInfo.objectId,
          name: organisationInfo.name
        });
      }
      this.organisationLists = result;
    });
  }

  async getDepartment() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Department', [{ condition: 'equalTo', field: 'isActive', value: true },
    { field: 'name', condition: 'descending' },
    { condition: 'equalTo', field: 'industry', value: { __type: 'Pointer', className: 'Industry', objectId: this.industryId } }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let departmentInfo = JSON.parse(jsonText);
        result.push({
          id: departmentInfo.objectId,
          name: departmentInfo.name
        });
      }
      this.departmentList = result;
    });
  }

  getRoleId() {
    let roleId = '';
    this.profileValue.role.forEach(element => {
      if (element.isActive) {
        roleId = element.objectId;
      }
    });
    return roleId;
  }

  async getRole() {
    let result = [];
    this.queryInterface.queryRole(this.parseService)
      .then(results => {
        for (let i = 0; i < results.length; i++) {
          let jsonText = JSON.stringify(results[i]);
          let roleInfo = JSON.parse(jsonText);
          result.push({ id: roleInfo.objectId, name: roleInfo.name });
        }
        this.roleList = result;
      });
  }

  async getReportingTo() {
    var result = [];
    let reportingToEmployee = false;
    this.queryInterface.queryUserReporting(this.parseService, reportingToEmployee);
  }

  async getDropDowns() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let result = await query.find();
    var dropdownresults = result[0],
      profileDropDownValue = this.profileDropDown.getProfileDropDown(
        dropdownresults
      ),
      religionObj = this.religionList,
      startTimeObj = this.startTimeList,
      genderObj = this.genderList,
      marriedObj = this.maritalStatusList,
      bloodGroupObj = this.bloodGroupList,
      religionList = profileDropDownValue.religions,
      bloodGroupList = profileDropDownValue.bloodGroup,
      genderList = profileDropDownValue.gender,
      maritalStatusList = profileDropDownValue.married,
      startTimeList = profileDropDownValue.startTime;

    for (var i = 0; i < religionList.length; i++) {
      religionObj.push(religionList[i]);
    }
    for (var i = 0; i < bloodGroupList.length; i++) {
      bloodGroupObj.push(bloodGroupList[i]);
    }
    for (var i = 0; i < genderList.length; i++) {
      genderObj.push(genderList[i]);
    }
    for (var i = 0; i < maritalStatusList.length; i++) {
      marriedObj.push(maritalStatusList[i]);
    }
    for (var i = 0; i < startTimeList.length; i++) {
      startTimeObj.push(startTimeList[i]);
    }
  }

  /*
  ** ==========================================================
  ** Twilight Details Save Function
  ** ==========================================================
  */
  // twilightDetailsSave() {
  //   var profileValues = this.twilightDetailsForm.value;
  //   let data = {
  //     officialInfo: {
  //       seatNo: profileValues.seatNo,
  //       reportingDate: this.dateConvertor.addGMTOffset(new Date(profileValues.reportingDate)).toISOString(),
  //       doj: this.dateConvertor.addGMTOffset(new Date(profileValues.doj)).toISOString(),
  //       officialEmail: profileValues.officialEmail,
  //       experience: {
  //         year: profileValues.yearofExperiences,
  //         month: profileValues.months
  //       },
  //       gitUserId: profileValues.gitUserId,
  //       startTime: profileValues.startTime,
  //       panNumber: profileValues.panNumber,
  //       salaryAccountNumber: profileValues.salaryAccountNumber,
  //       personalAccountNumber: profileValues.personalAccountNumber

  //     }
  //   }
  //   if (this.twilightDetailsForm.valid) {
  //     this.profileInterface.updateProfile(this.profileId, data, profileValues, this.locationList, this.organisationLists, this.departmentList, this.roleList, this.reportingtoList);
  //     this.toastr.success(this.toastMessage.Save);
  //   }
  // }

  onFormValuesChanged(formgroup) {
    for (const field in this.formErrors) {
      if (!this.formErrors.hasOwnProperty(field)) {
        continue;
      }
      this.formErrors[field] = {}; // Clear previous errors
      // Get the control
      if (formgroup == 'personalDetailsForm') {
        const control = this.personalDetailsForm.get(field);
        if (control && control.dirty && !control.valid) {
          this.formErrors[field] = control.errors;
        }
      }
    }
  }
  // on clicking skip button(Invited-User)
  onSkip() {
    this.router.navigate(['/employees-dashboard']);
  }

  mobileNoValidated(mobileNumber: object) {
    if (mobileNumber != null) {
      this.isMobileNumberEmpty = false;
    }
    else if (!this.personalDetailsForm.untouched && mobileNumber === null) {
      this.isMobileNumberEmpty = true;
    }
  }

}
